"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollableCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const FeatureIcon_1 = __importDefault(require("../../FeatureIcon/FeatureIcon"));
const ScrollableCard = (props) => {
    const className = classnames_1.default({
        'scrollable-card': true,
    });
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "header" },
            React.createElement("div", { className: "header-inner" },
                props.icon && React.createElement(FeatureIcon_1.default, { icon: props.icon, color: "blue" }),
                React.createElement("h4", null, props.title))),
        React.createElement("div", { className: "scrollable-card-body" }, props.children)));
};
exports.ScrollableCard = ScrollableCard;
//# sourceMappingURL=ScrollableCard.js.map